import {Checkbox, Form, Input, Modal, Radio, Select, Space, Button, Row, Col, message, Spin, Card, Typography} from "antd";
import React, {useContext, useEffect, useState, contextHolder}  from "react";
import {Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import GlobalSelect from "../../generales/GlobalSelect";
import {FormattedMessage} from "react-intl";
import {CloseOutlined, SaveOutlined, CarOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

const { Title } = Typography;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const FormAddTipoVehiculo = ({accion}) => {

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      };

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);

    const [spinning, setSpinning] = useState(false);

    const [spinTitle, setSpinTitle] = useState("Guardando información ...");

    const [title, setTitle] = useState((accion=="mod")?"Modificar Característica":"Adicionar Tipo Vehículo");

    const navigate = useNavigate();

    const { id } = useParams();

    const [form] = Form.useForm();
    const [canSubmit, setCanSubmit] = useState(false);

    const {t, i18n} = useTranslation();

    useEffect(() => {
        if(accion == "mod"){
            if(!sessionStorage.getItem('user_mod')){
                navigate('/tipovehiculo');
            }else{
                let user_mod = JSON.parse(sessionStorage.getItem('user_mod'));

                form.setFieldsValue({
                    "denominacion": user_mod.denominacion,
                    "activo": (user_mod.activo === "1") ? 1 : 0
                });

                // Verificar si puede enviar el formulario al cargar datos de modificación
                setCanSubmit(user_mod.denominacion && user_mod.denominacion.trim().length > 0);
            }
        } else {
            // Para nuevos registros, verificar el estado inicial
            const initialDenominacion = form.getFieldValue('denominacion');
            setCanSubmit(initialDenominacion && initialDenominacion.trim().length > 0);
        }
    }, [accion, form, navigate]);

    const tailLayout = {
        wrapperCol: { marginTop:10, offset: 8, span: 16 },
      };


    const cancelar = (values) => {
        navigate('/tipovehiculo');
    }

    const onFinish = (values) => {
        // console.log('Success:', values);
        form.setFieldsValue({
            "denominacion": values.denominacion
            });
        setSpinning(true);
        if(accion === "add"){
            setSpinTitle('Guardando datos...');
            Axios.post("sd/addTipoVehiculo",
                    {
                      "denominacion": values.denominacion,
                      "activo": values.activo
                    },
                    {
                        headers: headers
                      }
                ).then(response => {
                  setSpinning(false);
                    if(response.data.success){
                        messageApi.open({
                            type: 'success',
                            content: response.data.message,
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                        navigate('/tipovehiculo');
                    }else{
                        messageApi.open({
                            type: 'error',
                            content: 'Error al guardar los datos',
                            duration: 0,
                        });

                        setTimeout(messageApi.destroy, 2500);
                    }
            })
                .catch(error => {
                    setSpinning(false);
                    messageApi.open({
                        type: 'error',
                        content: 'Error al guardar los datos',
                        duration: 0,
                    });

                    setTimeout(messageApi.destroy, 2500);


                });
        }else if(accion === "mod"){
            setSpinTitle('Modificando datos...');
            Axios.post("sd/updateTipoVehiculo",
            {
              "idtipovehiculo": id,
              "denominacion": values.denominacion,
              "activo": values.activo,
            },
            {
                headers: headers
              }
        ).then(response => {
          setSpinning(false);
            if(response.data.success){
                messageApi.open({
                    type: 'success',
                    content: response.data.message,
                    duration: 0,
                });

                setTimeout(messageApi.destroy, 2500);

                navigate('/tipovehiculo');
            }else{
                messageApi.open({
                    type: 'error',
                    content: response.data.message,
                    duration: 0,
                });

                setTimeout(messageApi.destroy, 2500);
            }
        })
        .catch(error => {
            setSpinning(false);
            messageApi.open({
                type: 'error',
                content: 'Error al guardar los datos',
                duration: 0,
            });

            setTimeout(messageApi.destroy, 2500);
        });
        }

      };
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "24px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "800px",
                    margin: "0 auto"
                }}>
                    {/* Header */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '12px 12px 0 0',
                        padding: '24px',
                        color: 'white'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '48px',
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}>
                                <CarOutlined />
                            </div>
                            <div>
                                <Title level={2} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '24px'
                                }}>
                                    {title}
                                </Title>
                                <p style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    margin: 0,
                                    fontSize: '14px'
                                }}>
                                    {accion === "mod" ? "Modifica los datos del tipo de vehículo" : "Completa los datos del nuevo tipo de vehículo"}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Form Content */}
                    <Card style={{
                        borderRadius: '0 0 12px 12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        border: 'none'
                    }}>
                        {contextHolder}

                        {/* Vehicle Information Section */}
                        <div style={{
                            background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                            borderRadius: '12px',
                            padding: '20px',
                            marginBottom: '24px',
                            border: '1px solid #e0e6ff'
                        }}>
                            <Title level={4} style={{
                                color: '#253289',
                                marginBottom: '16px',
                                fontSize: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                🚚 Información del Tipo de Vehículo
                            </Title>

                            <Form
                                form={form}
                                autoComplete="on"
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                layout="vertical"
                                name="form_in_modal"
                                initialValues={{
                                    activo: 1,
                                }}
                                onValuesChange={(changedValues, allValues) => {
                                    // Verificar si denominación está llena
                                    const denominacion = allValues.denominacion;
                                    setCanSubmit(denominacion && denominacion.trim().length > 0);
                                }}
                            >
                                <Form.Item
                                    name="denominacion"
                                    label="Denominación"
                                    rules={[{ required: true, message: 'Por favor ingrese la denominación' }]}
                                >
                                    <Input
                                        placeholder="Ej: Camión, Camioneta, Motocicleta..."
                                        style={{ height: '40px' }}
                                    />
                                </Form.Item>

                                {/* Status Section dentro del Form */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                                    borderRadius: '12px',
                                    padding: '20px',
                                    marginTop: '24px',
                                    border: '1px solid #e0e6ff'
                                }}>
                                    <Title level={4} style={{
                                        color: '#253289',
                                        marginBottom: '16px',
                                        fontSize: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        ⚙️ Estado
                                    </Title>

                                    <Form.Item
                                        name="activo"
                                        style={{ margin: 0 }}
                                    >
                                        <Radio.Group>
                                            <Radio value={1} style={{ fontSize: '14px' }}>
                                                <span style={{ color: '#52c41a', fontWeight: '500' }}>
                                                    <FormattedMessage id="modulo_user_btn_activar" defaultMessage="Activo"/>
                                                </span>
                                            </Radio>
                                            <Radio value={0} style={{ fontSize: '14px', marginLeft: '16px' }}>
                                                <span style={{ color: '#ff4d4f', fontWeight: '500' }}>
                                                    <FormattedMessage id="modulo_user_btn_desactivar" defaultMessage="Inactivo"/>
                                                </span>
                                            </Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                {/* Action Buttons dentro del Form */}
                                <div style={{
                                    textAlign: "center",
                                    paddingTop: '16px',
                                    borderTop: '1px solid #f0f0f0',
                                    marginTop: '24px'
                                }}>
                                    <Space size="middle">
                                        <Button
                                            icon={<CloseOutlined/>}
                                            danger
                                            onClick={cancelar}
                                            size="large"
                                            style={{
                                                height: '40px',
                                                paddingLeft: '24px',
                                                paddingRight: '24px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            {t('global.cancel')}
                                        </Button>
                                        <Button
                                            icon={<SaveOutlined/>}
                                            type="primary"
                                            htmlType="submit"
                                            size="large"
                                            disabled={!canSubmit}
                                            style={{
                                                background: canSubmit
                                                    ? 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)'
                                                    : '#d9d9d9',
                                                borderColor: canSubmit ? '#253289' : '#d9d9d9',
                                                height: '40px',
                                                paddingLeft: '24px',
                                                paddingRight: '24px',
                                                fontWeight: '500',
                                                color: canSubmit ? 'white' : '#000000',
                                                boxShadow: canSubmit ? '0 2px 8px rgba(37, 50, 137, 0.3)' : 'none'
                                            }}
                                        >
                                            {t('global.save')}
                                        </Button>
                                    </Space>
                                </div>
                            </Form>
                        </div>
                    </Card>
                </div>
            </Spin>
        </div>


    );
};

export default FormAddTipoVehiculo;